function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { toJalaali } from '../utils/date-persian.js';
import DarkMixin from './dark.js';
import FormMixin from './form.js';
import ListenersMixin from './listeners.js';
import { pad } from '../utils/format.js';
var calendars = ['gregorian', 'persian'];
export default {
  mixins: [DarkMixin, FormMixin, ListenersMixin],
  props: {
    value: {
      required: true
    },
    mask: {
      type: String
    },
    locale: Object,
    calendar: {
      type: String,
      validator: function validator(v) {
        return calendars.includes(v);
      },
      "default": 'gregorian'
    },
    landscape: Boolean,
    color: String,
    textColor: String,
    square: Boolean,
    flat: Boolean,
    bordered: Boolean,
    readonly: Boolean,
    disable: Boolean
  },
  computed: {
    computedMask: function computedMask() {
      return this.__getMask();
    },
    computedLocale: function computedLocale() {
      return this.__getLocale();
    },
    editable: function editable() {
      return this.disable !== true && this.readonly !== true;
    },
    computedColor: function computedColor() {
      return this.color || 'primary';
    },
    computedTextColor: function computedTextColor() {
      return this.textColor || 'white';
    },
    computedTabindex: function computedTabindex() {
      return this.editable === true ? 0 : -1;
    },
    headerClass: function headerClass() {
      var cls = [];
      this.color !== void 0 && cls.push("bg-".concat(this.color));
      this.textColor !== void 0 && cls.push("text-".concat(this.textColor));
      return cls.join(' ');
    }
  },
  methods: {
    __getLocale: function __getLocale() {
      return this.locale !== void 0 ? _objectSpread(_objectSpread({}, this.$q.lang.date), this.locale) : this.$q.lang.date;
    },
    __getCurrentDate: function __getCurrentDate(dateOnly) {
      var d = new Date();
      var timeFill = dateOnly === true ? null : 0;

      if (this.calendar === 'persian') {
        var jDate = toJalaali(d);
        return {
          year: jDate.jy,
          month: jDate.jm,
          day: jDate.jd
        };
      }

      return {
        year: d.getFullYear(),
        month: d.getMonth() + 1,
        day: d.getDate(),
        hour: timeFill,
        minute: timeFill,
        second: timeFill,
        millisecond: timeFill
      };
    },
    __getCurrentTime: function __getCurrentTime() {
      var d = new Date();
      return {
        hour: d.getHours(),
        minute: d.getMinutes(),
        second: d.getSeconds(),
        millisecond: d.getMilliseconds()
      };
    },
    __getDayHash: function __getDayHash(date) {
      return date.year + '/' + pad(date.month) + '/' + pad(date.day);
    }
  }
};